import ProgressBar from "@/components/ProgressBar/ProgressBar";
import Skeleton from "@/components/Skeleton/Skeleton";
import { CaretDownFilled, CaretRightFilled } from "@ant-design/icons";
import { useState } from "react";
import { formatCarbonFootprint } from "../utils/formatters";
import ghgStyles from "./GhgDashboard.module.scss";
import GhgTableScopeLevel from "./GhgTableScopeLevel";
import { IGetGhg, IScope } from "./types";

export default function GhgTableScope({
  scope,
  data,
  loading,
}: {
  scope: IScope;
  data?: IGetGhg;
  loading?: boolean;
}) {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <>
      <div
        className={`${ghgStyles.row} ${ghgStyles.header}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <div>{isOpen ? <CaretDownFilled /> : <CaretRightFilled />}</div>
        <div className={ghgStyles.name}>{scope.label}</div>
        <div>
          {loading ? (
            <Skeleton style={{ height: "12px", width: "60px" }} />
          ) : (
            formatCarbonFootprint(data?.[scope.key] || 0)
          )}
        </div>
        <div>
          <ProgressBar
            type="blue"
            size="small"
            value={(data?.[scope.key] || 0) / (data?.total || 1)}
          />
        </div>
      </div>
      {isOpen &&
        scope.levels.map((level) => (
          <GhgTableScopeLevel
            scope={scope}
            level={level}
            data={data}
            loading={loading}
          />
        ))}
    </>
  );
}
